import { useQuery } from '@tanstack/react-query';

import getActiveOperators from 'Api/monitoring/getActiveOperators';

import getActiveOperatorsResponse from './model/response/getActiveOperatorsResponse';

const useGetActiveOperators = () => {
  return useQuery({
    queryKey: ['active-operators'],
    queryFn: async () => {
      const response = await getActiveOperators();

      const result = getActiveOperatorsResponse(response);

      return result;
    },
    refetchOnWindowFocus: false,
    retry: false,
    gcTime: 0,
  });
};

export default useGetActiveOperators;
